export const SUPPORTED_LOCALES = ['en', 'de', 'fr', 'es'] as const;

export type SupportedLocale = typeof SUPPORTED_LOCALES[number];

// Matches a whole leading locale segment: '/de/courses' → '/de', '/enroll/x' → no match
export const LOCALE_PREFIX_PATTERN = new RegExp(`^/(${SUPPORTED_LOCALES.join('|')})(?=/|$)`);
